import intlTelInput from 'intl-tel-input'

const contact = {
	state: {
		iti: null,
	},

	elements: {
		$contactSection:     $('.js-contact'),
		$contactTitle:       $('.js-contact-title'),
		$fixedContactButton: $('.js-contact-fixed'),
		$form:               $('.js-contact-form'),
		$formMessage:        $('.js-contact-form-message'),
		$formSubmit:         $('.js-contact-form-submit'),
		$image:              $('.js-contact-image'),
		$formCountry:        $('.js-form-field-country'),
		$formPhone:          $('.js-form-field-phone'),
	},

	modifiers: {
		fixedContactButtonHidden: 'contact-fixed--hidden',
		formMessageHidden:        'contact-form__message--hidden',
		formMessageSuccess:       'contact-form__message--success',
		formMessageError:         'contact-form__message--error',
	},

	init() {
		this.initEvents()
		this.initAnimations()
		this.initContactForm()
	},

	initAnimations() {
		window.gsap.timeline({
			defaults:      {
				ease: 'none',
			},
			scrollTrigger: {
				trigger:             this.elements.$image,
				start:               () => `top top`,
				end:                 () => `bottom bottom`,
				scrub:               true,
				invalidateOnRefresh: true,
			},
		}).to(this.elements.$image, {
			'--transform-progress': 1,
		})

		window.gsap.timeline({
			defaults:      {
				ease: 'none',
			},
			scrollTrigger: {
				trigger:             this.elements.$contactSection,
				start:               'top bottom',
				end:                 'top top',
				scrub:               true,
				invalidateOnRefresh: true,
				onEnter:             () => {
					this.elements.$fixedContactButton.addClass(this.modifiers.fixedContactButtonHidden)
				},
				onLeaveBack:         () => {
					this.elements.$fixedContactButton.removeClass(this.modifiers.fixedContactButtonHidden)
				},
			},
		}).to(this.elements.$contactSection, {
			'--mask-progress': 1,
		}, 0)
	},

	initEvents() {
		this.elements.$form.on('submit', this.handleFormSubmit.bind(this))
	},

	handleFormSubmit(e) {
		e.preventDefault()

		const formData = new FormData(this.elements.$form[0])

		const data = {
			firstname: formData.get('first-name'),
			lastname:  formData.get('last-name'),
			email:     formData.get('email'),
			phone:     this.state.iti.getNumber(),
			zipcode:   formData.get('zip-code'),
			country:   formData.get('country'),
			comments:  formData.get('comments'),
			optin:     formData.get('accept_terms') ? 1 : 0,
		}

		$.ajax({
			url:     'https://api.veya-yachts.com/api/prospects',
			method:  'POST',
			data:    data,
			success: () => {
				this.elements.$formMessage.text(this.elements.$form.data('success-message'))
				this.elements.$formMessage.removeClass(this.modifiers.formMessageHidden)
				this.elements.$formSubmit.prop('disabled', true)

				this.elements.$formMessage.removeClass(this.modifiers.formMessageError).addClass(this.modifiers.formMessageSuccess)
			},
			error:   (error) => {
				this.elements.$formMessage.html(this.elements.$form.data('error-message') + '<br/>' + Object.values(error.responseJSON.errors).join('<br/>'))
				this.elements.$formMessage.removeClass(this.modifiers.formMessageHidden)

				this.elements.$formMessage.addClass(this.modifiers.formMessageError).removeClass(this.modifiers.formMessageSuccess)
			},
		})
	},

	initContactForm() {
		const countryData = intlTelInput.getCountryData()

		// populate the country dropdown
		for (let i = 0; i < countryData.length; i++) {
			const country    = countryData[i]
			const optionNode = document.createElement('option')
			optionNode.value = country.iso2
			const textNode   = document.createTextNode(country.name)
			optionNode.appendChild(textNode)
			this.elements.$formCountry[0].appendChild(optionNode)
		}

		this.state.iti = intlTelInput(this.elements.$formPhone[0], {
			initialCountry: 'us',
			nationalMode:   true,
			containerClass: 'form-field',
			loadUtils:      () => import('intl-tel-input/utils'), // for formatting/placeholders etc
		})
		this.state.iti.telInput.classList.add('form-field__input')

		// set address dropdown's initial value
		this.elements.$formCountry[0].value = this.state.iti.getSelectedCountryData().iso2

		// listen to the telephone input for changes
		this.elements.$formPhone[0].addEventListener('countrychange', () => {
			this.elements.$formCountry[0].value = this.state.iti.getSelectedCountryData().iso2
		})

		// listen to the address dropdown for changes
		this.elements.$formCountry[0].addEventListener('change', () => {
			this.state.iti.setCountry(this.elements.$formCountry[0].value)
		})
	},
}

export default contact
